import React from 'react';
import Head from 'shared/components/Head/Head';
import { ListingHeadProps } from './ListingHead.types';
import { getSeoSchemaJson } from 'listing-details/helpers/seoSchemaJson';
import { getOpenGraphValues } from 'shared/helpers/openGraph';
import {
    LISTING_IMAGE_URL_CROPPED_PREFIX,
    ZOOPLA_PRODUCTION_URL
} from 'listing-details/constants';

const ListingHead = ({ data }: ListingHeadProps) => {
    const { listing, breadcrumbs } = data;
    const images = listing.propertyImage || [];
    const imageBasePath = `${LISTING_IMAGE_URL_CROPPED_PREFIX}${1024}/${768}/`;
    const mainImageSrc = `${imageBasePath}${images[0]?.filename}`;
    const canonicalUrl = listing.listingUris.detail || '';
    const url = `${ZOOPLA_PRODUCTION_URL}${canonicalUrl}`;
    const type = 'website';

    return (
        <Head
            pageTitle={listing.metaTitle}
            pageDescription={listing.metaDescription}
            canonicalPath={canonicalUrl}
            renderSocialSharingTags={true}
            openGraphValues={getOpenGraphValues(
                url,
                listing.metaTitle,
                type,
                mainImageSrc,
                listing.metaDescription
            )}
            schema={() =>
                getSeoSchemaJson(
                    url,
                    canonicalUrl,
                    imageBasePath,
                    breadcrumbs,
                    listing
                )
            }
        />
    );
};

export default ListingHead;
